module.exports = __webpack_public_path__ + "img/018-focus.042c2e05.svg";